export const getPdfUrl = (path) => {
  const pdfBaseUrl = process.env.REACT_APP_PDF_CDN;
  return `${pdfBaseUrl}${path}`;
};

export const getBackendApiCallUrl = (endpoint) => {
  const backendUrl = process.env.REACT_APP_BACKEND_API_URL
  console.log("Test dans function : ", backendUrl);
  return `${backendUrl}${endpoint}`;
}